module.exports = __webpack_public_path__ + "static/cover-collage-transparency-1fddb163977c9e467f04a5135d7fab06.png";